import { render, staticRenderFns } from "./addedit-services.vue?vue&type=template&id=7561cf6c"
import script from "./addedit-services.vue?vue&type=script&lang=js"
export * from "./addedit-services.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports